import { render, staticRenderFns } from "./ShipmentPackages.vue?vue&type=template&id=44f68ae2&"
import script from "./ShipmentPackages.vue?vue&type=script&lang=js&"
export * from "./ShipmentPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports